import { useEffect } from 'react';
import { connect } from 'react-redux';
import { setActiveLink } from '../navmenu/navbarSlice';
import { Button, Row, Col, Card, Alert } from 'react-bootstrap';
import { pingAsync } from './healthSlice';
import {apiRequest, loginRequest} from '../../authConfig';
import { useMsal } from '@azure/msal-react';
import { useAppSelector, useAppDispatch } from '../../app/hooks';

export const Health = () => {
  const dispatch = useAppDispatch();
  const pingMessage = useAppSelector(state => state.health.pingMessage?.message);

  useEffect(() => {
    dispatch(setActiveLink('/health'));
  }, [dispatch]);

  const { instance, accounts } = useMsal();

  const requestApiAccessToken = async (): Promise<string> => {
    const request = {
      ...apiRequest,
      account: accounts[0],
    };

    try {
      const response = await instance.acquireTokenSilent(request);
      return response.accessToken;
    } catch (error) {
      const response = await instance.acquireTokenSilent(request);
      return response.accessToken;
    }
  };

  const ping = async () => {
    const apiToken = await requestApiAccessToken();
    dispatch(pingAsync({ apiToken: apiToken }));
  };

  return (
    <Row>
      <Col xs={12}>
        <Card className="text-center">
          <Card.Header as="h2">API</Card.Header>
          <Card.Body>
            <Col className="mb-3">
              <Button variant="primary" onClick={async () => ping()}>
                Ping API
              </Button>
            </Col>
            {pingMessage && (
              <Alert variant="success">
                <Alert.Heading>Success</Alert.Heading>
                API responded with {pingMessage}
              </Alert>
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default connect()(Health);
